var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('p',{staticClass:"note"},[_vm._v(_vm._s(_vm.$t("Remove the notification block from Settings > Advanced > Content-settings > Notifications")))])])}
var staticRenderFns = []

export { render, staticRenderFns }